import * as Sentry from '@sentry/react';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { sentryErrorsHandlersOptions } from '@src/configs/sentry.configs';

import { App } from './App';
import { CHUNK_RELOAD_COOLDOWN } from './constants/app.constants';
import { STORAGE_KEY } from './constants/storage.constants';

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();

  const now = Date.now();

  const lastReloadAt = Number(
    sessionStorage.getItem(STORAGE_KEY.CHUNK_RELOAD) ?? 0,
  );

  if (now - lastReloadAt < CHUNK_RELOAD_COOLDOWN) {
    return;
  }

  Sentry.captureMessage('Vite chunk preload error', {
    level: 'warning',
    extra: {
      error: event.payload,
    },
  });

  sessionStorage.setItem(STORAGE_KEY.CHUNK_RELOAD, String(now));

  window.location.reload();
});

createRoot(
  document.getElementById('root')!,
  sentryErrorsHandlersOptions,
).render(
  <StrictMode>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </StrictMode>,
);
